import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import SinglePost from "./SinglePost";
import Navbar from "./Navbar";
import Home from "./Home";
import About from "./About";
import Contact from "./Contact";
import Conservation from "./Conservation";
import CheckoutStep1 from "./CheckoutStep1";
import CheckoutStep2Wrapper from "./CheckoutStep2";
import Education from "./Education";
import EmailFailure from "./EmailFailure";
import KanziSlideshow from "./KanziSlideshow";
import KanziCelebration from "./KanziCelebration";
import KanziCelebrationTitle from "./KanziFadeTitle";
import Mission from "./Mission";
import Store from "./Store";
import SueBiblio from "./SueBiblio";
import Research from "./Research";
import Timeline from "./Timeline";
import Login from "./Login";
import Posts from "./Posts";
import CreatePost from "./CreatePost";
import EditPost from "./EditPost";
import Footer from "./Footer";
import DonationPage from "./DonationPage";
import DonationSuccess from "./DonationSuccess";
import DonationEmailFailure from "./DonationEmailFailure";
import Cart from "./Cart";
import "./styles.css";
import BonoboHopeKeyboard from "./BonoboHopeKeyboard";
import Products from "./Products";
import ProductDetails from "./ProductDetails";
import Info from "./Info";
import Success from "./Success";
import Failure from "./Failure";
import VideoSection from "./VideoSection";
import PrivacyPolicy from "./PrivacyPolicy";
import ReactGA from "react-ga4";

// Initialize Google Analytics with your Measurement ID
ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID);

const App = () => {
  const [loggedIn, setLoggedIn] = useState(
    !!localStorage.getItem("accessToken")
  );
  const [cart, setCart] = useState(() => {
    try {
      const savedCart = localStorage.getItem("cart");
      return savedCart ? JSON.parse(savedCart) : [];
    } catch (e) {
      console.error("Failed to parse cart from localStorage:", e);
      return [];
    }
  });

  // Track page views with React Router and scroll to top
  const location = useLocation();
  useEffect(() => {
    // Google Analytics pageview tracking
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
    });
    // Scroll to top on route change
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    setLoggedIn(!!localStorage.getItem("accessToken"));
  }, []);

  useEffect(() => {
    console.log("Cart updated in App.js:", cart);
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("cart");
    setCart([]);
    setLoggedIn(false);
  };

  // Function to clear cart explicitly
  const clearCart = () => {
    console.log("Clearing cart in App.js...");
    setCart([]);
    localStorage.removeItem("cart");
    console.log("Cart cleared in App.js");
  };

  return (
    <div className="app-container">
      <Navbar loggedIn={loggedIn} onLogout={handleLogout} cart={cart} />
      <div className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/posts" element={<Posts />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/Conservation" element={<Conservation />} />
          <Route path="/KanziCelebration" element={<KanziCelebration />} />
          <Route path="/KanziSlideshow" element={<KanziSlideshow />} />
          <Route
            path="/KanziCelebrationTitle"
            element={<KanziCelebrationTitle />}
          />
          <Route path="/Mission" element={<Mission />} />
          <Route path="/post/:id" element={<SinglePost />} />
          <Route path="/store" element={<Store />} />
          <Route path="/products" element={<Products />} />
          <Route
            path="/product/:id"
            element={<ProductDetails cart={cart} setCart={setCart} />}
          />
          <Route
            path="/cart"
            element={<Cart cart={cart} setCart={setCart} />}
          />
          <Route
            path="/checkout/step1"
            element={<CheckoutStep1 setCart={setCart} />}
          />
          <Route
            path="/checkout/step2"
            element={<CheckoutStep2Wrapper setCart={clearCart} />}
          />
          <Route path="/success" element={<Success />} />
          <Route path="/donation-success" element={<DonationSuccess />} />
          <Route path="/failure" element={<Failure />} />
          <Route path="/email-failure" element={<EmailFailure />} />
          <Route
            path="/donation-email-failure"
            element={<DonationEmailFailure />}
          />
          <Route path="/info" element={<Info />} />
          <Route path="/video" element={<VideoSection />} />
          <Route path="/SueBiblio" element={<SueBiblio />} />
          <Route path="/history/*" element={<Timeline />} />
          <Route path="/donate" element={<DonationPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/BonoboHopeKeyboard" element={<BonoboHopeKeyboard />} />
          <Route
            path="/login"
            element={<Login onLogin={() => setLoggedIn(true)} />}
          />
          {loggedIn && (
            <>
              <Route path="/django-posts" element={<Posts />} />
              <Route path="/create-post" element={<CreatePost />} />
              <Route path="/edit-post/:id" element={<EditPost />} />
              <Route
                path="/logout"
                element={
                  <div>
                    <h2>Are you sure you want to log out?</h2>
                    <button onClick={handleLogout}>Logout</button>
                  </div>
                }
              />
            </>
          )}
        </Routes>
      </div>
      <Footer loggedIn={loggedIn} />
    </div>
  );
};

// Wrap App with Router to provide useLocation context
const AppWithRouter = () => (
  <Router>
    <App />
  </Router>
);

export default AppWithRouter;
